export default function TrophyIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M6.66667 17.5026H13.3333M10 14.1693V17.5026M10 14.1693C11.1051 14.1693 12.1649 13.7303 12.9463 12.9489C13.7277 12.1675 14.1667 11.1077 14.1667 10.0026V3.33594H5.83333V10.0026C5.83333 11.1077 6.27232 12.1675 7.05372 12.9489C7.83512 13.7303 8.89493 14.1693 10 14.1693ZM2.5 7.5026C2.5 7.94463 2.67559 8.36855 2.98816 8.68112C3.30072 8.99368 3.72464 9.16927 4.16667 9.16927C4.60869 9.16927 5.03262 8.99368 5.34518 8.68112C5.65774 8.36855 5.83333 7.94463 5.83333 7.5026C5.83333 7.06058 5.65774 6.63665 5.34518 6.32409C5.03262 6.01153 4.60869 5.83594 4.16667 5.83594C3.72464 5.83594 3.30072 6.01153 2.98816 6.32409C2.67559 6.63665 2.5 7.06058 2.5 7.5026ZM14.1667 7.5026C14.1667 7.94463 14.3423 8.36855 14.6548 8.68112C14.9674 8.99368 15.3913 9.16927 15.8333 9.16927C16.2754 9.16927 16.6993 8.99368 17.0118 8.68112C17.3244 8.36855 17.5 7.94463 17.5 7.5026C17.5 7.06058 17.3244 6.63665 17.0118 6.32409C16.6993 6.01153 16.2754 5.83594 15.8333 5.83594C15.3913 5.83594 14.9674 6.01153 14.6548 6.32409C14.3423 6.63665 14.1667 7.06058 14.1667 7.5026Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
